var _path, _rect;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 180,
    height: 150,
    "data-version": 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m106.86 35.26-1.13 46.11q0 22.7 4.37 35.95 4.94 15.65 19.6 15.65 10.15 0 17.41-17.34t7.41-50.34q-24.68-3.66-24.68-21 0-6.35 4.02-10.44t10.93-4.09q10.85 0 16.28 7.69 5.43 7.68 6.14 22.91 6.48.28 10.57.28.85.14.85 1.48 0 1.34-.57 2.05-1.41 2.11-6.77 2.11h-4.23q-1.26 54.99-23.26 68.53-6.35 3.8-14.1 3.8-22.28 0-31.3-25.09-3.1 9.16-8.46 15.01-5.36 5.85-10.72 7.97-5.36 2.11-11.28 2.11-31.44 0-31.44-43.42v-24.4q-.14-18.04-3.24-25.09-3.11-7.05-8.89-7.05-13.25 0-13.25 26.5-.28.85-1.55.85t-1.98-.56q-2.11-1.41-2.11-6.77 0-12.97 5.5-19.74 5.5-6.77 15.08-6.77 13.54 0 18.33 8.6 4.8 8.6 4.8 30.03v25.1q0 20.16 4.44 28.62t13.89 8.46q9.45 0 14.66-7.75 10.3-15.37 10.3-84.74 0-4.09 2.46-6.35 2.47-2.25 5.5-2.25t6.42 3.38m29.47 8.6q0 11.85 18.04 15.23-.42-13.25-2.75-18.33-2.32-5.08-6.34-5.08t-6.49 2.4q-2.46 2.4-2.46 5.78",
    paintOrder: "stroke"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: -86.575,
    y: -54.425,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(92.555 84.685)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatify);
export default __webpack_public_path__ + "static/media/chatify.818085a8b823aa90ee7ad9e4ae2dd82b.svg";
export { ForwardRef as ReactComponent };